import type { ReactNode } from 'react';
import type { InvoiceStatus } from '@/types/invoice';

interface Props { variant: InvoiceStatus | 'paid' | 'pending' | 'draft' | 'sent' | 'overdue'; children?: ReactNode }

const MAP: Record<string, { cls: string; label: string }> = {
  processing: { cls: 'badge-pending', label: 'Traitement en cours' },
  ready: { cls: 'badge-paid', label: 'Prête' },
  failed: { cls: 'badge-overdue', label: 'Échouée' },
  edited: { cls: 'badge-sent', label: 'Modifiée' },
  paid: { cls: 'badge-paid', label: 'Payée' },
  pending: { cls: 'badge-pending', label: 'En attente' },
  draft: { cls: 'badge-draft', label: 'Brouillon' },
  sent: { cls: 'badge-sent', label: 'Envoyée' },
  overdue: { cls: 'badge-overdue', label: 'En retard' },
};

export function Badge({ variant, children }: Props) {
  const entry = MAP[variant] ?? MAP.draft;
  return (
    <span className={`badge ${entry.cls}`}>
      <span className="dot" aria-hidden />
      {children ?? entry.label}
    </span>
  );
}
